/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from "react";
import Layout from "../../layout/Layout";
import { NavLink, json, useNavigate } from "react-router-dom";
import { ThreeDots } from "react-loader-spinner";
import { getListeEntite } from "../../services/entite/EntiteRequest";
import MomoLogo from "./../../assets/images/momo_school_blue.jpeg";
import HospitalLogo from "./../../assets/images/hopital (2).png";

const Entite = () => {
  const navigate = useNavigate();
  const [pageQuery, setPageQuery] = useState({
    page: 0,
    size: 7,
    nombrePage: 1,
  });
  const [loadingData, setLoadingData] = useState(false);
  const [entiteListe, setEntiteListe] = useState([]);

  useEffect(() => {
    setLoadingData(true);
    localStorage.removeItem("menuListSchool");
    localStorage.removeItem("entiteSchool");
    localStorage.removeItem("entiteSchoolCode");
    localStorage.removeItem("sousEntiteId");
    getListeEntite(pageQuery.page, 10)
      .then((res) => {
        setLoadingData(false);
        setEntiteListe(res.data.donnee.entites);
        setPageQuery((prev) => ({
          ...prev,
          nombrePage: res.data.donnee.totalPages,
        }));
      })
      .catch((err) => {
        setLoadingData(false);
        console.log("api error", err);
        if (err.response && err.response.status === 401) {
          localStorage.removeItem("momo4scoohclient");
          navigate("/login");
        }
      });
  }, []);

  return (
    <Layout>
      <div className="w-11/12 h-full mx-auto pt-32">
        <p className="text-3xl text-center font-bold">
          Sélectionnez une entité
        </p>

        <div className="w-10/12 mx-auto mt-16">
          {entiteListe.length !== 0 && !loadingData ? (
            <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-y-6">
              {entiteListe.map((item, index) => (
                <div
                  onClick={() => {
                    localStorage.setItem(
                      "menuListSchool",
                      JSON.stringify(item.menus)
                    );
                    localStorage.setItem("entiteSchool", item.designation);
                    localStorage.setItem("entiteSchoolCode", item.code);
                    localStorage.setItem("entiteRoute", item.entiteRoot);
                    localStorage.setItem("currentEntity", JSON.stringify(item));
                  }}
                >
                  <NavLink to="/sous-entites">
                    <div className="flex flex-col gap-y-2 items-center justify-center bg-white w-64 h-40 mx-auto rounded-lg shadow p-3 cursor-pointer">
                      {/* {item.code === "SCHOOL" ? <img src={MomoLogo} className="w-12 -mt-2" /> : null} */}
                      {item.code === "SCHOOL" ? (
                        <img src={MomoLogo} className="w-14 -mt-2" />
                      ) : item.code === "HOSPITAL" ? (
                        <img
                          src={HospitalLogo}
                          className="w-12 -mt-2 bg-[#29668b] rounded-full p-[0.5rem]"
                        />
                      ) : null}
                      <p className="text-xl font-bold">{item.designation}</p>
                    </div>
                  </NavLink>
                </div>
              ))}
            </div>
          ) : entiteListe.length === 0 && loadingData ? (
            <div className="w-80 mx-auto h-16 rounded-md bg-white flex items-center justify-center">
              <p className="text-lg text-gray-800 font-bold">Chargement...</p>
            </div>
          ) : null}

          {entiteListe.length === 0 && !loadingData ? (
            <div className="w-80 mx-auto h-16 rounded-md bg-red-100 flex items-center justify-center">
              <p className="text-lg text-red-800 font-bold">
                Aucune entité trouvée
              </p>
            </div>
          ) : null}
        </div>
      </div>
    </Layout>
  );
};

export default Entite;
